import { Card } from "antd";
import styled from "styled-components";

export const AdvancedFilterCard = styled(Card)`
  &.ant-card {
    margin-bottom: 12px;

    .ant-card-body {
      padding: 16px;
    }
  }
`;
